import { render, staticRenderFns } from "./DextBillsDownload.vue?vue&type=template&id=6fa1ba74&scoped=true"
import script from "./DextBillsDownload.vue?vue&type=script&lang=js"
export * from "./DextBillsDownload.vue?vue&type=script&lang=js"
import style0 from "./DextBillsDownload.vue?vue&type=style&index=0&id=6fa1ba74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa1ba74",
  null
  
)

export default component.exports